import { PURGE } from 'redux-persist';

const initialState = {
  activeJobs: [], // [{ jobId, type, label, total, progress, status }]
};

const Jobs = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE:
      return initialState;

    case 'JOB_ADD':
      return { ...state, activeJobs: [...state.activeJobs, { jobId: payload.jobId, type: payload.type, total: payload.total, meta: payload.meta || {}, progress: 0, status: 'running' }] };

    case 'JOB_PROGRESS':
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, progress: payload.progress } : j) };

    case 'JOB_COMPLETED':
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, progress: 100, status: 'completed' } : j) };

    case 'JOB_FAILED':
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, status: 'failed', error: payload.error } : j) };

    case 'JOB_CANCELLED':
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, status: 'cancelled' } : j) };

    case 'JOB_STATUS': {
      const { jobId, ...rest } = payload;
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === jobId ? { ...j, ...rest } : j) };
    }

    case 'JOB_DISMISS':
      return { ...state, activeJobs: state.activeJobs.filter(j => j.jobId !== payload.jobId) };

    default:
      return state;
  }
};

export default Jobs;
